"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextField = void 0;

var tslib_1 = require("tslib");

var ui_box_1 = require("@hopin-team/ui-box");

var ui_field_error_message_1 = require("@hopin-team/ui-field-error-message");

var ui_field_helper_message_1 = require("@hopin-team/ui-field-helper-message");

var ui_field_label_1 = require("@hopin-team/ui-field-label");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_with_space_1 = require("@hopin-team/ui-helper-with-space");

var ui_icon_1 = require("@hopin-team/ui-icon");

var nanoid_1 = require("nanoid");

var react_1 = tslib_1.__importStar(require("react"));

var icon_1 = require("./styled/icon");

var input_1 = require("./styled/input");

var TextField = (0, react_1.forwardRef)(function (_a, ref) {
  var __UIScope = _a.__UIScope,
      autocomplete = _a.autocomplete,
      className = _a.className,
      currentCount = _a.currentCount,
      errorMessage = _a.errorMessage,
      hasErrors = _a.hasErrors,
      helperText = _a.helperText,
      id = _a.id,
      isDisabled = _a.isDisabled,
      isInverse = _a.isInverse,
      isRequired = _a.isRequired,
      label = _a.label,
      leadingIcon = _a.leadingIcon,
      maxCount = _a.maxCount,
      _b = _a.multiLine,
      multiLine = _b === void 0 ? false : _b,
      name = _a.name,
      placeholder = _a.placeholder,
      _c = _a.requiredText,
      requiredText = _c === void 0 ? 'required' : _c,
      _d = _a.size,
      size = _d === void 0 ? 'medium' : _d,
      trailingIcon = _a.trailingIcon,
      _e = _a.type,
      type = _e === void 0 ? 'text' : _e,
      props = tslib_1.__rest(_a, ["__UIScope", "autocomplete", "className", "currentCount", "errorMessage", "hasErrors", "helperText", "id", "isDisabled", "isInverse", "isRequired", "label", "leadingIcon", "maxCount", "multiLine", "name", "placeholder", "requiredText", "size", "trailingIcon", "type"]);

  var fieldId = (0, react_1.useMemo)(function () {
    return "".concat(id !== null && id !== void 0 ? id : (0, nanoid_1.nanoid)());
  }, [id]);
  var charCountId = "".concat(fieldId, "--char-count");
  var errorMsgId = (0, react_1.useMemo)(function () {
    return "error-msg-".concat(id !== null && id !== void 0 ? id : (0, nanoid_1.nanoid)());
  }, [id]);
  var helperMsgId = (0, react_1.useMemo)(function () {
    return "helper-msg-".concat(id !== null && id !== void 0 ? id : (0, nanoid_1.nanoid)());
  }, [id]);

  var _f = (0, ui_helper_deep_branding_1.useEscapeClasses)({
    block: 'TextField',
    className: className,
    __UIScope: __UIScope
  }),
      makeClasses = _f.makeClasses,
      rootClasses = _f.rootClasses;

  var a11yProps = {};

  if (hasErrors && errorMessage) {
    a11yProps['aria-describedby'] = errorMsgId;
  }

  if (!hasErrors && helperText) {
    a11yProps['aria-describedby'] = helperMsgId;
  }

  var inputProps = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, a11yProps), props), multiLine ? {} : {
    type: type
  });

  var tagName = multiLine ? 'textarea' : 'input';
  return react_1.default.createElement("div", {
    className: rootClasses
  }, react_1.default.createElement(ui_field_label_1.FieldLabel, {
    className: makeClasses('Label'),
    charCountId: charCountId,
    currentCount: currentCount,
    fieldId: fieldId,
    isDisabled: isDisabled,
    isInverse: isInverse,
    isRequired: isRequired,
    label: label,
    maxCount: maxCount,
    requiredText: requiredText,
    mb: 0.5
  }), react_1.default.createElement(ui_box_1.Box, {
    isRelative: true
  }, react_1.default.createElement(input_1.Input, tslib_1.__assign({
    as: tagName,
    className: makeClasses('Input'),
    "aria-describedby": charCountId,
    "aria-invalid": hasErrors,
    disabled: isDisabled,
    hasErrors: hasErrors,
    id: fieldId,
    name: name,
    placeholder: placeholder,
    ref: ref,
    required: isRequired,
    sizeOption: size,
    autoComplete: autocomplete,
    isLeading: Boolean(leadingIcon),
    isTrailing: Boolean(trailingIcon),
    maxLength: maxCount,
    isInverse: isInverse
  }, inputProps)), (leadingIcon || trailingIcon) && react_1.default.createElement(icon_1.IconWrapper, {
    isLeading: Boolean(leadingIcon),
    isTrailing: Boolean(trailingIcon)
  }, react_1.default.createElement(ui_icon_1.Icon, {
    name: leadingIcon !== null && leadingIcon !== void 0 ? leadingIcon : trailingIcon,
    title: "".concat(leadingIcon !== null && leadingIcon !== void 0 ? leadingIcon : trailingIcon, " icon"),
    color: hasErrors ? 'utility-error' : 'grey-800'
  }))), hasErrors && errorMessage && react_1.default.createElement(ui_field_error_message_1.FieldErrorMessage, {
    className: makeClasses('ErrorMessage'),
    mt: 1,
    errorMessage: errorMessage,
    id: errorMsgId,
    isInverse: isInverse
  }), !hasErrors && helperText && react_1.default.createElement(ui_field_helper_message_1.FieldHelperMessage, {
    helperMessage: helperText,
    mt: 1,
    className: makeClasses('HelperMessage'),
    id: helperMsgId,
    isInverse: isInverse
  }));
});
TextField.displayName = 'TextField';
var TextFieldWithSpace = (0, ui_helper_with_space_1.withSpace)(TextField);
exports.TextField = TextFieldWithSpace;